import type { WorkerMissionStatus } from '@/types/mission';

export interface MissionWorker {
	availableStatuses: WorkerMissionStatus[];
	email: string;
	firstname: string;
	id: string;
	lastname: string;
	phone: string;
	picture: string | null;
	workerId: string;
	workerStatus: WorkerMissionStatus;
}

export interface MissionList {
	id: string;
	status: MissionStatus;
	name: string;
	totalPositions: number;
	periods: Array<MissionPeriod>;
	city: string;
	contractType: string;
	states: MissionState[];
	availableActions: MissionAction[];
	confirmedWorkers: number;
	workers: MissionWorker[];
	workersSelection: Array<{
		workerStatus: WorkerMissionStatus;
		quantity: number;
	}>;
}

export enum MissionStatus {
	TO_PROCESS = 'TO_PROCESS',
	TO_VALIDATE = 'TO_VALIDATE',
	VALIDATED = 'VALIDATED',
	CANCELED = 'CANCELED',
}

export enum MissionState {
	WORKER_TO_CONFIRM = 'worker-to-confirm',
	WORKER_TO_REPLACE = 'worker-to-replace',
	EXPIRED = 'expired',
	SYNC_WITH_EVOLIA = 'sync-with-evolia',
	EXTENDED = 'extended',
}

export interface WorkersSelection {
	workerStatus: WorkerMissionStatus;
	quantity: number;
}

export enum MissionSlotClass {
	IN_PROGRESS = 'in-progress',
	ACCEPTED = 'accepted',
	PROPOSED = 'proposed',
}

export enum PlanningSidebarColor {
	BLUE = 'blue',
	YELLOW = 'yellow',
	GREEN = 'green',
	GRAY = 'gray',
}

export type MissionPeriod = {
	start: number; // timestamp jour + heure
	end: number; // timestamp jour + heure
};

export enum MissionAction {
	DETAILS = 'details',
	PROPOSITIONS = 'propositions',
	EDIT = 'edit',
	DUPLICATE = 'duplicate',
	SEND_TO_EVOLIA = 'sendToEvolia',
	EXTEND = 'extend',
	VALIDATE = 'validate',
	CANCEL = 'cancel',
	ADD_WORKERS = 'addWorkers',
}
